import React, { useState, useMemo } from 'react';
import { ListItem, ListItemText, Box, Typography } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import TooltipHelpButton from '../buttons/TooltipHelpButton/TooltipHelpButton';
import { randomString } from '../../utilities/randomUtilities';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { theme } from '../../App/MuiTheme';

const styles = theme => ({
    group: {
        width: '100%',
    },
    button: {
        flex: '1 0 auto',
        height: theme.spacing(4),
        color: 'rgba(255, 255, 255, 0.48)',
        background: 'rgba(0, 0, 0, 0.2)',
        border: '1px solid rgba(255, 255, 255, 0.23)',
        transition: theme.transitions.create('background', {
			easing: theme.transitions.easing.easeInOut,
			duration: theme.transitions.duration.shortest,
		})
    },
});

const ToggleButtonListItem = ({ classes, value, text, onChange, lineBreak, options, toolTip }) => {
    const labelId = useMemo(() => randomString(), []);
    const [lastValue, setLastValue] = useState(value);

    const handleChange = (event, newValue) => {
        const finalValue = newValue || lastValue;
        onChange(finalValue);
        setLastValue(finalValue);
    }

    const buttonGroup = (
        <ToggleButtonGroup
            value={value}
            exclusive
            onChange={handleChange}
            aria-labelledby={labelId}
            size='small'
            className={classes.group}
        >
            {options.map((option) => 
                <ToggleButton 
                    value={option.value}
                    key={option.value}
                    className={classes.button}
                >
                    {option.text}
                </ToggleButton>
            )}
        </ToggleButtonGroup>
    );

    return (
        <ListItem style={{minHeight: lineBreak ? null : theme.spacing(6)}}>
            <ListItemText>
                <Typography 
                    gutterBottom={lineBreak}
                    variant='body2'
                    id={labelId}
                    style={{fontWeight: 'inherit'}}
                >
                    {text}
                    {toolTip && <TooltipHelpButton title={toolTip} />}
                </Typography>
                {lineBreak && buttonGroup}
            </ListItemText>
            {!lineBreak && (
                <Box>
                    {buttonGroup}
                </Box>
            )}
        </ListItem>
    );
}

export default withStyles(ToggleButtonListItem, styles);